import { themes } from '@helpers/brand';
import { setCssVar } from '@helpers/cssVar';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
import SiteWide from '../Global/SiteWide/SiteWide';
const Container = styled.section `
  --sectionMargin: ${fluid(64, 102)};
  ${setCssVar('sitePadding', '18px')};
  ${setCssVar('siteWidth', '100%')};

  @media ${from(Device.DesktopLarge)} {
    ${setCssVar('sitePadding', '18px')};
    ${setCssVar('siteWidth', '1312px')};
  }

  ${({ flush, themeOption }) => themeOption === 'light' &&
    css `
      margin-top: ${flush === 'both' || flush === 'top' ? 0 : `calc(var(--sectionMargin) / 2)`};
      margin-bottom: ${flush === 'both' || flush === 'bottom' ? 0 : `calc(var(--sectionMargin) / 2)`};
    `}

  ${({ flush, themeOption }) => themeOption !== 'light' &&
    css `
      padding-top: ${flush === 'both' || flush === 'top' ? 0 : `calc(var(--sectionMargin) / 2)`};
      padding-bottom: ${flush === 'both' || flush === 'bottom' ? 0 : `calc(var(--sectionMargin) / 2)`};
    `}

  ${({ themeOption }) => themeOption &&
    css `
      ${themes[themeOption]}
    `}
`;
const StyledSiteWide = styled(SiteWide) ``;
export default {
    Container,
    SiteWide: StyledSiteWide,
};
